import { ReactElement } from 'react';

interface Props {
  label: string;
  value: string;
  trend?: number;
  icon: ReactElement;
  className?: string;
}

const MetricWidget: React.FC<Props> = ({
  label,
  value,
  trend = null,
  icon,
  className = '',
}) => {
  return (
    <div
      className={`overflow-hidden bg-white rounded-lg shadow-md ${className}`}
    >
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">{icon}</div>
          <div className="flex-1 w-0 ml-5">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">
                {label}
              </dt>
              <dd>
                <div className="text-lg font-bold text-gray-900">{value}</div>
              </dd>
            </dl>
          </div>
          {trend && (
            <div className="flex-1 w-0 ml-5 text-right">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  Trend
                </dt>
                <dd>
                  <div className="text-lg font-bold text-red-500">N/A</div>
                </dd>
              </dl>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MetricWidget;
